import React from 'react';
import { AdminAuthProvider, useAdminAuth } from '../contexts/AdminAuthContext';
import AdminLoginPage from '../components/Admin/AdminLoginPage';
import AdminDashboardNocode from '../components/Admin/AdminDashboardNocode';
import { Loader2 } from 'lucide-react';

const AdminContent = () => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return isAuthenticated ? <AdminDashboardNocode /> : <AdminLoginPage />;
};

const AdminNocodePage = () => {
  return (
    <AdminAuthProvider>
      <AdminContent />
    </AdminAuthProvider>
  );
};

export default AdminNocodePage;
